<template>
  <div>
    <van-cell-group title="抄送人" :border="true" size="large">
      <div class="approvers">
          <van-row type="flex" justify="center" class="approver">
            <van-col span="6" v-for="copyto in copytos" :key="copyto.id">
              <van-image
                round
                width="3rem"
                height="3rem"
                :src="copyto.thumb_avatar"
              />
              <h3>{{copyto.name}}</h3>
              <p>{{copyto.position}}</p>
            </van-col>

          </van-row>
          
        <van-divider />
        </div>
      
      
   
  </van-cell-group>
    
  </div>
</template>

<script>
export default {
  name: 'CopyTo',
  props: {
    copytos:Array,

  },
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.approvers{
  text-align: 0 auto;
  /* margin:10px; */
  /* margin-bottom:100px; */
}
.approver{
  /* float:left; */
  padding:10px;

}

.approver .van-step{
  display:block;

}
h3 {
  font-size:12px;
  margin:5px;
}
p{
  margin:0px;
  font-size:12px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.van-cell-group__title{
  background-color:#3f51b5 ;
  font-size:14px;
  font-weight:blod;
  color:white;
  padding:13px;

}
</style>
